import { render } from "./ShiDuanCompile.vue?vue&type=template&id=24ef1ca8&scoped=true"
import script from "./ShiDuanCompile.vue?vue&type=script&lang=js"
export * from "./ShiDuanCompile.vue?vue&type=script&lang=js"

import "./ShiDuanCompile.vue?vue&type=style&index=0&id=24ef1ca8&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ef1ca8"]])

export default __exports__